/**
 * Sanitização de filename.
 *
 * Regras (do spec Section 4):
 *  - Remove path separators (/, \) — evita path traversal no unzip
 *  - Remove control chars (0x00–0x1F) — podem quebrar parsers
 *  - Trim de "." no início — evita "../etc/passwd" virar "../etc/passwd"
 *  - Limite 200 chars após sanitização
 *  - Retorna "" se nada sobrar (caller decide se rejeita)
 *
 * Preserva:
 *  - Espaços (válidos em ZIP)
 *  - Acentos e Unicode (válidos em ZIP/NFS)
 *  - "." no meio (ex: "foto.final.png" → "foto.final.png")
 */

const MAX_LENGTH = 200;
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\x00-\x1F]/g;
const PATH_SEPARATORS = /[/\\]/g;

/**
 * Sanitiza um filename user-controlled.
 * @param {string} name
 * @returns {string} sanitizado (pode ser "")
 */
export function sanitizeFilename(name) {
  if (typeof name !== 'string') return '';
  let out = name
    .replace(PATH_SEPARATORS, '')
    .replace(CONTROL_CHARS, '')
    .replace(/^\.+/, '') // trim de pontos no início
    .trim();

  if (out.length > MAX_LENGTH) {
    out = out.slice(0, MAX_LENGTH);
  }

  return out;
}
